import api from '~/utils/api';
import { OrderEditType } from '~/utils/constants';
import { makeCrewAction, makeCrewLoader, redirect } from '~/utils/routing';

export const { action, useActionResult } = makeCrewAction(
  async ({ context }, appStore) => {
    const { orderEdit } = appStore.getState();

    if (orderEdit.step !== 'reviewing') {
      return redirect('../');
    }

    const { step, ...body } = orderEdit;
    return api
      .commitOrderEdit({
        params: {
          storefrontId: context.settings.storefrontId,
          storeOrderId: context.order.id,
        },
        body,
      })
      .then((resp) => {
        if (resp.ok) {
          appStore.dispatch(appStore.actions.orderEditCommit());
        }
        return resp;
      });
  },
);

const headlines = {
  UPDATE_SHIPPING_ADDRESS: 'Update Shipping Address',
  CANCEL_ORDER: 'Cancel Order',
} as const satisfies Record<
  (typeof OrderEditType)[keyof typeof OrderEditType],
  string
>;

export const { loader, useLoaderData } = makeCrewLoader(
  ({ context }, appStore) => {
    const { orderEdit } = appStore.getState();
    const { order } = context;

    if (orderEdit.step !== 'reviewing') return redirect('../');

    const { step, ...data } = orderEdit;

    return {
      ...data,
      currentAddress: order.shippingAddress,
      headline: headlines[data.editType],
    };
  },
);
